"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const renderer_1 = require("@react-pdf/renderer");
const styles = renderer_1.StyleSheet.create({
    invoiceNoContainer: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginTop: 36,
        marginLeft: 'auto',
        backgroundColor: '#EFEFEF',
        padding: 10,
    },
    invoiceContainer: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginTop: 2,
    },
    label: {
        width: 'auto',
        fontWeight: 'bold',
        color: 'gray',
    },
    labelDetail: {
        width: 'auto',
    },
    invoiceNoLeft: {
        flexDirection: 'column',
        width: '25%',
        textAlign: 'left',
    },
    invoiceNoRight: {
        flexDirection: 'column',
        justifyContent: 'flex-end',
        width: '35%',
        textAlign: 'right',
    },
});
const InvoiceNo = ({ invoice }) => (react_1.default.createElement(renderer_1.View, { style: styles.invoiceNoContainer },
    react_1.default.createElement(renderer_1.View, { style: styles.invoiceNoLeft },
        react_1.default.createElement(renderer_1.Text, { style: styles.label }, "Num\u00E9ro de facture :"),
        react_1.default.createElement(renderer_1.Text, { style: styles.label }, "Date de la facture : "),
        react_1.default.createElement(renderer_1.Text, { style: styles.label }, "Identit\u00E9 client : "),
        react_1.default.createElement(renderer_1.Text, { style: styles.label }, "E-mail client : ")),
    react_1.default.createElement(renderer_1.View, { style: styles.invoiceNoRight },
        react_1.default.createElement(renderer_1.Text, { style: styles.labelDetail }, invoice.invoice_no),
        react_1.default.createElement(renderer_1.Text, { style: styles.labelDetail }, invoice.trans_date),
        react_1.default.createElement(renderer_1.Text, { style: styles.labelDetail }, invoice.client),
        react_1.default.createElement(renderer_1.Text, { style: styles.labelDetail }, invoice.clientMail))));
exports.default = InvoiceNo;
